<template>
  <div class="login-container flex flex-center">
    <div class="logo-pic">
      <img src="https://hr.xcxd.cn/image/logo.png" alt="logo" />
    </div>
    <div class="login-footer">
      <span>
        Copyright © 2019-2020&nbsp;&nbsp;&nbsp;&nbsp;北京兴长信达科技发展有限公司&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color: #ffffff"
        >京ICP备10009123号-19</a>&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040170"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color: #ffffff"
        >
          <img src="../assets/gawb.png" style="float:left;margin-right: 4px;" />
          京公网安 11010502040170号
        </a>
      </span>
    </div>
    <div class="login-wrapper">
      <div class="login-pic">
        <img src="https://hr.xcxd.cn/image/login_pic.png" alt="login" />
      </div>
      <div class="login-qrcode flex flex-center">
        <div v-show="!adminLogin" class="login-container__admin">
          <iframe
            v-if="iframeShow"
            :src="redirectUrl"
            scrolling="no"
            frameborder="0"
            class="login-container__admin__iframe"
          ></iframe>
          <div v-else class="login-container__admin__code" id="login_container"></div>
          <div @click="loginAdmin" class="login-container__admin__button" style="cursor:pointer">
            <a-icon type="user" style="margin-right:10px" />账号登录
          </div>
        </div>
        <div v-show="adminLogin" class="login-container__admin">
          <a-form
            ref="loginForm"
            :form="form"
            class="login-form"
            auto-complete="on"
            label-position="left"
          >
            <div class="title-container">
              <h3 class="title">登录到{{appTitle}}</h3>
            </div>
            <a-form-item prop="account">
              <a-input
                size="large"
                type="text"
                placeholder="请输入账号"
                v-decorator="[
                'account',
                {rules: [{ required: true, message: '请输入邮箱地址' }, {type: 'email', message:'请输入正确的邮箱'}], validateTrigger: 'change'}
              ]"
              >
                <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-item>
            <a-form-item prop="password">
              <a-input
                size="large"
                :type="passwordType"
                autocomplete="false"
                @keyup.enter.native="login"
                placeholder="请输入密码"
                v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
              >
                <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                <a-icon v-if="passwordType" slot="suffix" type="eye" @click="showPwd" />
                <a-icon v-else slot="suffix" type="eye-invisible" @click="showPwd" />
              </a-input>
            </a-form-item>
            <a-button
              :loading="loading"
              type="primary"
              class="green-btn"
              style="width:100%;margin-bottom:30px;"
              @click.native.prevent="login"
            >登录</a-button>
            <div class="login-container__admin">
              <div @click="loginOther" style="cursor:pointer">
                <a-icon type="qrcode" style="margin-right:10px" />扫码登录
              </div>
            </div>
          </a-form>
        </div>
      </div>
    </div>
    <!--
    
    -->
  </div>
</template>

<script>
import { axios } from "@/utils/request";

export default {
  name: "app",

  data() {
    return {
      value: "",
      redirect_url: "",
      form: this.$form.createForm(this),
      hanndleMessage: "",
      adminLogin: false,
      loginForm: {
        account: "",
        password: ""
      },
      passwordType: "password",
      loading: false,
      redirectUrl: "",
      iframeShow: true
    };
  },
  computed: {
    appTitle() {
      return this.$config.title;
    }
  },
  async created() {
    const parameter = this.getRequest(window.location.href);
    this.redirect_url = parameter.redirect_url ? parameter.redirect_url : "";
    if (!this.redirect_url) {
      this.$message.error("回调地址为空");
      return;
    }

    const login_data = await axios.get("/login-type");
    const login_type = login_data.data.data.login_type;
    if (login_type == "dingding" || login_type == "wechat") {
      this.adminLogin = false;
      const rep = await axios.get(
        `/get-login-code?redirect_url=${this.redirect_url}`
      );
      let redirectUrl = rep.data.data.code;
      this.redirectUrl = redirectUrl;
      if (rep.data.data.type == "wechat") {
        this.iframeShow = true;
      } else {
        this.iframeShow = false;
        this.dingdinglogin();
      }
    } else {
      this.adminLogin = true;
    }
  },
  methods: {
    dingdinglogin() {
      var goto = encodeURIComponent(this.redirectUrl);
      const parameterCode = this.getRequest(this.redirectUrl);
      this.$nextTick(() => {
        var obj = DDLogin({
          id: "login_container",
          goto: goto,
          style: "border:none;background-color:none;",
          width: "280",
          height: "320"
        });
      });
      var hanndleMessage = function(event) {
        var origin = event.origin;
        if (origin == "https://login.dingtalk.com") {
          var loginTmpCode = event.data;
          window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${parameterCode.appid}&response_type=code&scope=snsapi_login&state=${parameterCode.state}&redirect_uri=${parameterCode.redirect_uri}/login&loginTmpCode=${loginTmpCode}`;
        }
      };
      if (typeof window.addEventListener != "undefined") {
        window.addEventListener("message", hanndleMessage, false);
      } else if (typeof window.attachEvent != "undefined") {
        window.attachEvent("onmessage", hanndleMessage);
      }
    },

    getRequest(url) {
      var theRequest = new Object();
      if (!url) return;
      if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1);
        const strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },

    async login() {
      if (this.loading) return;
      this.form.validateFields(async (err, values) => {
        if (values.account && values.password) {
          try {
            this.loading = true;
            await this.$store.dispatch("auth/login", {
              ...values,
              redirect_url: this.redirect_url
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },

    loginAdmin() {
      this.adminLogin = true;
    },

    loginOther() {
      this.adminLogin = false;
    },

    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    }
  }
};
</script>
